<script>
</script>

<div class="form-box">
  <div class="mb-3">
    <h6 class="font-weight-bold">A Fortra representative can help you create or modify your record. Please fill out our Contact Us form and someone will be in touch within 24 hours.</h6>
  </div>

  <div class="mb-3">
    <a href="/contact-us" class="btn btn-1 btn-lg">Contact Us</a>
  </div>
</div>

<style>

</style>
